import React from 'react';
import {FtButton} from "@/common/FtButton";

interface Props {
    error: string;
    onRetry?: () => void;
}

export function ErrorMessage({error, onRetry}: Props) {
    return (
        <div
            style={{
                display: "flex",
                flexDirection: "column",
                justifyContent: "center",
                alignItems: "center",
                minHeight: "100vh",
                gap: 16
            }}
        >

            <div style={{color: 'red', whiteSpace: 'pre-wrap', textAlign: 'center'}}>
                {error}
            </div>

            {onRetry && (
                <FtButton variant="contained" onClick={onRetry}>
                    다시 시도
                </FtButton>
            )}
        </div>
    );
} 